import { useState, useEffect } from 'react';

const useResponsivePageSize = (initialPageSize) => {
    const [pageSize, setPageSize] = useState(initialPageSize);

    useEffect(() => {
        const breakpoints = [
            { maxHeight: 600, size: 5 },
            { maxHeight: 825, size: 8 },
            { maxHeight: 940, size: 17 },
            { maxHeight: 950, size: 17 },
            { maxHeight: 960, size: 17 },
        ];
        const defaultSize = 17;

        const updatePageSize = () => {
            const screenHeight = window.innerHeight;

            const matchedBreakpoint = breakpoints.find(
                (bp) => screenHeight <= bp.maxHeight
            );
            setPageSize(matchedBreakpoint ? matchedBreakpoint.size : defaultSize);
        };
        
        updatePageSize();
        
        const debouncedUpdate = debounce(updatePageSize, 100);
        window.addEventListener('resize', updatePageSize);
        return () => window.removeEventListener('resize', debouncedUpdate);
    }, []);

    return pageSize;
};

// Simple debounce function
const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func(...args), delay);
    };
};

export default useResponsivePageSize;
